<template>
  <a-result status="404" title="頁面錯誤" :sub-title="subTitle" class="not_found_container">
  </a-result>
</template>

<script>
    export default {
      data(){
        return {
          subTitle:'訪問的頁面不存在'
        }
      },
      mounted() {
        const {
          error
        } = this.$route.query;

        if(!error){
          return;
        }
        /**
         * hino app 以車號嵌入開通系統，若車號不存在則後端傳出base64加密後的訊息
         */
        if(typeof error === 'string' && Object.is('deviceNotOpen',atob(error)) ){
          this.subTitle = '裝置未開通';
        }

      },
    }
</script>

<style lang="scss" scoped>
    .not_found_container {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
</style>
